import React from "react";
import { ReactComponent as PowerOnIcon } from "./Icons/power_on.svg";
import "./CSS/PowerOn.css";

const PowerOn = ({ clicked }) => {
  return (
    <div className="power-on-screen">
      <PowerOnIcon
        className="power-on-icon"
        onClick={clicked}
        role="button"
        aria-label="Power on"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            clicked();
          }
        }}
      />
      <p className="power-on-text">Power On</p>
    </div>
  );
};

export default PowerOn;
